import { render, staticRenderFns } from "./sSearchPerson.vue?vue&type=template&id=0edf360e"
import script from "./sSearchPerson.vue?vue&type=script&lang=js"
export * from "./sSearchPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports